// Phase I0.3 — Pill primitive.
// 11px Bebas Neue label with 4×8 padding, radius 3, hairline border.
// Used as a compact category / tier / state marker.

import type { CSSProperties, ReactNode } from "react";

export interface PillProps {
  children: ReactNode;
  /** Optional foreground colour. Defaults to --sa-fg-secondary. */
  color?: string;
  /** Optional border colour. Defaults to --sa-hairline. */
  borderColor?: string;
  /** Optional background. Defaults to transparent. */
  background?: string;
  style?: CSSProperties;
}

export function Pill({
  children,
  color = "var(--sa-fg-secondary)",
  borderColor = "var(--sa-hairline)",
  background = "transparent",
  style,
}: PillProps) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "4px 8px",
        borderRadius: 3,
        border: `1px solid ${borderColor}`,
        background,
        color,
        fontFamily: "var(--sa-font-stat)",
        fontSize: 11,
        letterSpacing: "0.14em",
        lineHeight: 1,
        textTransform: "uppercase",
        ...style,
      }}
    >
      {children}
    </span>
  );
}
